export default __webpack_public_path__ + "static/google-7c5f7f4d367c098dadfba689e5a9ad00.png";